
import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllCalibrationResponseModel, CalibrationDto, CalibrationReq, CalibrationResponseModel } from '@gtpl/shared-models/hrms';
import axios from 'axios';
import connection from './connection';

export class CalibrationService {

  URL = connection.DEPLOY_URL + '/calibrations';

  async createCalibration(calibration: CalibrationDto): Promise<CalibrationResponseModel> {
    return await axios
      .post(this.URL + '/createCalibration', calibration)
      .then((res) => {
        return res.data;
      });
  }

  async calibrateFileUpload(req: any): Promise<CalibrationResponseModel> {
    return await axios
      .post(this.URL + '/calibrateFileUpload', req)
      .then((res) => {
        return res.data;
      });
  }

  async updateCalibration(dto: CalibrationDto): Promise<CalibrationResponseModel> {
    console.log('update calibration');
    return await axios.post(this.URL + '/updateCalibration', dto)
      .then((res) => {
        return res.data;
      });
  }

  async getAllActiveCalibrations(): Promise<AllCalibrationResponseModel> {
    return await axios.post(this.URL + '/getAllActiveCalibrations').then((res) => {
      return res.data;
    });
  }

  async getAllCalibrations(req?:CalibrationReq): Promise<AllCalibrationResponseModel> {
    return await axios.post(this.URL + '/getAllCalibrations',req).then((res) => {
      return res.data;
    });
  }

  async activateOrDeactivateData(
    calibrationDto: CalibrationDto
  ): Promise<CalibrationResponseModel> {
    return await axios
      .post(this.URL + '/activateOrDeactivateData', calibrationDto)
      .then((res) => {
        return res.data;
      });
  }


} 